import { getTerms } from "./terms"
import { termsKeys } from "./queryKeys"
import { useQuery } from "@tanstack/react-query"

export const useGetTermsQuery = (archive_loc: string | null) => {
  return useQuery({
    queryKey: termsKeys.detail(archive_loc),
    queryFn: () => getTerms(archive_loc as string),
    enabled: false,
    retry: false,
  })
}
